<template>
    <b-row align-v="start" class="pb-3">
      <b-col sm="3" align="center" class="label-col pb-3 pt-2">
        <label :label-for="id">{{titleText}}</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :id="id"
                      :type="inputType || 'text'"
                      v-model.trim.lazy="inputValue"
                      required
                      :disabled="isDisabled"
                      :state="isValid"
                      :placeholder="placeholder"/>

        <b-form-invalid-feedback :id="id + 'Invalid'"
                                 v-if="!(validation===undefined)"
                                 align="left">
          <font-awesome-icon :icon="['far','exclamation-triangle']"/>{{validationText}}
        </b-form-invalid-feedback>
        <b-form-text label-for="projectNameInput">{{description}}</b-form-text>
      </b-col>
    </b-row>
</template>

<script>

  import {getValidationMessages} from './../../../../js/validation/validationMessages.js'
  import {mapMutations} from 'vuex';

  export default {
    name: "RxTextEntryBox",

    props: {
      value: {
        type: String,
      },
      placeholder: {
        type: String,
        required: false,
      },
      description: {
        type: String,
        required: false,
      },
      titleText: {
        type: String,
        required: true
      },
      inputType: {
        type: String,
        required: false,
        default: 'text'
      },
      id: {
        type: String,
        required: true
      },
      validation: {
        type: Object,
        required: false
      },
      isDisabled:{
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      inputValue: {
        get() {
          return this.value
        },
        set(v) {
          if (this.validation !== undefined && this.validation !== null){
            // Use local validation tracking if this has a validator
            this.validation.$touch();
          } else {
            // Otherwise use the global page validation status
            this.setPageDirty()
          }
          this.$emit('input',v)
        }
      },
      isValid() {
        if (this.validation !== undefined && this.validation.$dirty){
          return !this.validation.$error
        } else {
          return null
        }
      },
      validationText() {
        if (this.validation !== undefined) {
          return getValidationMessages(this.validation)
        } else {
          return null
        }
      }
    },
    methods:{
      ...mapMutations('rx',[
        'setPageDirty'
      ])
    }
  }
</script>

<style scoped>
  .label-col {
    font-size: 1.2rem;
  }

  label {
    text-align: center;
  }

</style>